import React, { ReactNode } from "react";

export interface YoutubeValueProps {
  value: YoutubeProps;
}
interface YoutubeProps {
  id: string;
  className?: string;
}
const Youtube: React.FC<YoutubeValueProps> = ({ value }) => {
  const { id, className } = value;

  return (
 
      <iframe
        className={className}
        src={`https://www.youtube.com/embed/${id}?enablejsapi=1`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
  
  );
};
export default Youtube;
